export const CardComponent = {
  components: {
    Card: {
      baseStyle: {
        p: '0',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        position: 'relative',
        minWidth: '0px',
        bg: 'brand.front',
        wordWrap: 'break-word',
        backgroundClip: 'border-box',
        borderWidth: '1px',
        boxShadow: 'sm',
        borderRadius: '8px'
      }
    },
    CardHeader: {
      baseStyle: {
        display: 'flex',
        width: '100%',
        justifyContent: 'space-between',
        alignItems: 'center',
        p: '4'
      }
    },
    CardBody: {
      baseStyle: {
        display: 'block',
        width: '100%',
        p: '4'
      }
    },
    CardFooter: {
      baseStyle: {
        display: 'block',
        width: '100%',
        p: '4'
      }
    }
  }
}
